import React, { useEffect, useState } from 'react';
import { fetchEmployeeStories } from '../../lib/api';
import { Quote } from 'lucide-react';

export const EmployeeStories = () => {
  const [stories, setStories] = useState([]);

  useEffect(() => { fetchEmployeeStories().then(setStories).catch(() => setStories([])); }, []);

  if (!stories.length) return null;

  return (
    <section className="py-16 sm:py-20 bg-slate-50" data-testid="employee-stories-section">
      <div className="max-w-6xl mx-auto px-5 lg:px-8">
        <span className="text-xs font-semibold uppercase tracking-widest text-orange-500">Employee Stories</span>
        <h2 className="mt-2 text-2xl sm:text-3xl font-extrabold text-slate-900">My journey at Hipro</h2>
        <p className="mt-3 text-slate-600 max-w-2xl">Real stories from the people who build, design and grow with us — many of whom started as freshers straight from campus.</p>
        <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {stories.map((s) => (
            <figure key={s.id} data-testid={`employee-story-${s.id}`} className="flex flex-col rounded-2xl border border-slate-200 bg-white p-6 hover:shadow-lg hover:border-orange-200 transition-all">
              <Quote className="h-6 w-6 text-orange-400" />
              <blockquote className="mt-3 text-sm text-slate-700 leading-relaxed flex-1">“{s.quote}”</blockquote>
              <figcaption className="mt-5 flex items-center gap-3 pt-4 border-t border-slate-100">
                {s.photo && <img src={s.photo} alt={s.name} loading="lazy" className="h-12 w-12 rounded-full object-cover ring-2 ring-orange-100" />}
                <div>
                  <div className="text-sm font-bold text-slate-900">{s.name}</div>
                  <div className="text-xs text-slate-500">{s.role}{s.tenure ? ` · ${s.tenure}` : ''}</div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EmployeeStories;
